import React from 'react';
import PageTitle from 'modules/common/components/PageTitle';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useHistory, useLocation } from 'react-router-dom';
import { storage } from 'modules/common/helper';
import { Button } from 'modules/common/input';
import AddressPicker from '../../common/AddressPicker';
import { schema, INIT_FORM } from './constants';

function Address() {
  const address = storage.get('address');
  const [isLoading, setIfLoading] = React.useState(false);
  const history = useHistory();
  const { state } = useLocation();
  const is_edit = !!state?.is_edit;

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...INIT_FORM,
      ...address,
    },
    resolver: yupResolver(schema),
  });

  const handleOnSubmit = (form) => {
    setIfLoading(true);
    setTimeout(() => {
      setIfLoading(false);
      storage.set('address', form);
      history.push(
        is_edit ? '/register/review-details' : '/register/take-photo'
      );
    }, 500);
  };

  React.useEffect(() => () => history.replace({ state: '' }), [history]);

  return (
    <>
      <PageTitle title="Address | Manila E-Citizen" />
      <form onSubmit={handleSubmit(handleOnSubmit)}>
        <div className="space-y-4">
          <p className="text-primary-500 font-medium">Address</p>
          <Controller
            control={control}
            name="address"
            defaultValues={INIT_FORM?.address}
            render={({ field: { onChange, value } }) => {
              return (
                <AddressPicker
                  value={value}
                  isOneLine
                  disabledRegion
                  disabledProvince
                  required
                  errors={errors?.address}
                  onChange={(e) => {
                    onChange(e);
                  }}
                />
              );
            }}
          />
          <Button
            type="submit"
            isLoading={isLoading}
            className="btn primary md font-base text-sm"
            label={is_edit ? 'Submit' : 'Next'}
          />
        </div>
      </form>
    </>
  );
}
Address.defaultProps = {};

Address.propTypes = {};

export default Address;
